import { render, staticRenderFns } from "./ProfilesIndicator.vue?vue&type=template&id=d613f0d2&"
import script from "./ProfilesIndicator.vue?vue&type=script&lang=js&"
export * from "./ProfilesIndicator.vue?vue&type=script&lang=js&"
import style0 from "./ProfilesIndicator.vue?vue&type=style&index=0&id=d613f0d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports